import { useEffect, useState } from "react";
import { navItems } from "@/mocks/home";

const UPDATE_DATE = "2026-10-10";

export default function SiteHeader() {
  const [active, setActive] = useState<string>(navItems[0].id);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const ids = navItems.map((i) => i.id);
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(entry.target.id);
          }
        });
      },
      { rootMargin: "-45% 0px -50% 0px", threshold: 0 }
    );
    ids.forEach((id) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });
    return () => observer.disconnect();
  }, []);

  const handleJump = (id: string) => {
    setMenuOpen(false);
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <header className="sticky top-0 z-50">
      <div className="bg-foreground-950 text-background-50">
        <div className="w-full px-4 md:px-6 h-9 flex items-center justify-between gap-3 text-xs md:text-[13px] font-label">
          <div className="flex items-center gap-2 min-w-0">
            <span className="w-4 h-4 flex items-center justify-center shrink-0">
              <i className="ri-pulse-line text-primary-400"></i>
            </span>
            <span className="truncate">
              地址状态：正常访问 · 例行巡检
            </span>
          </div>
          <div className="hidden sm:flex items-center gap-4 shrink-0 text-background-200">
            <span>最近更新：{UPDATE_DATE}</span>
            <span className="text-primary-300">本页为信息指引，非官方站点</span>
          </div>
        </div>
      </div>

      <nav className="bg-background-50/90 backdrop-blur border-b border-background-200">
        <div className="w-full px-4 md:px-6 h-14 flex items-center justify-between gap-4">
          <button
            onClick={() => handleJump("top")}
            className="flex items-center gap-2.5 shrink-0 cursor-pointer"
          >
            <span className="w-9 h-9 rounded-md bg-primary-500 text-background-50 flex items-center justify-center">
              <i className="ri-book-2-line text-lg"></i>
            </span>
            <span className="flex flex-col items-start leading-none">
              <span className="font-heading font-bold text-foreground-950 text-base">老司机漫画</span>
              <span className="text-[11px] text-foreground-500 font-label mt-0.5">入口 · 地址 · 下载指南</span>
            </span>
          </button>

          <div className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <button
                key={item.id}
                onClick={() => handleJump(item.id)}
                className={`px-3.5 py-2 rounded-md text-sm font-label whitespace-nowrap transition-colors cursor-pointer ${
                  active === item.id
                    ? "bg-primary-100 text-primary-800"
                    : "text-foreground-700 hover:text-foreground-950 hover:bg-background-100"
                }`}
              >
                {item.label}
              </button>
            ))}
          </div>

          <div className="flex items-center gap-2">
            <button
              onClick={() => handleJump("entry-channel")}
              className="hidden md:inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-label whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
            >
              <i className="ri-compass-3-line"></i>
              查看入口
            </button>
            <button
              onClick={() => setMenuOpen((v) => !v)}
              aria-label="打开导航菜单"
              aria-expanded={menuOpen}
              className="lg:hidden w-9 h-9 flex items-center justify-center rounded-md border border-background-300 text-foreground-800 cursor-pointer"
            >
              <i className={menuOpen ? "ri-close-line text-lg" : "ri-menu-line text-lg"}></i>
            </button>
          </div>
        </div>

        {menuOpen && (
          <div className="lg:hidden border-t border-background-200 bg-background-50 px-4 py-3">
            <div className="grid grid-cols-2 gap-2">
              {navItems.map((item) => (
                <button
                  key={item.id}
                  onClick={() => handleJump(item.id)}
                  className={`px-3 py-2 rounded-md text-sm font-label text-left cursor-pointer ${
                    active === item.id
                      ? "bg-primary-100 text-primary-800"
                      : "bg-background-100 text-foreground-700"
                  }`}
                >
                  {item.label}
                </button>
              ))}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}